import React from 'react';
import classnames from 'classnames';
import InputMoney from './InputMoney';

export const text = ({ inputProps, inputType }) => (
  <input
    {...inputProps}
    value={inputProps.value}
    type={inputType}
    className="form__input"
  />
);

export const select = ({ inputProps, inputType, children }) => (
  <div className="form__select">
    <select {...inputProps} value={inputProps.value}>
      {children}
    </select>
  </div>
);

export const checkbox = ({ inputProps, inputType }) => (
  <label className="form__checkbox" htmlFor={inputProps.id}>
    <input
      {...inputProps}
      type={inputType}
      checked={inputProps.value[inputProps.name]}
    />
  </label>
);

export const money = ({ inputProps, inputType }) => (
  <InputMoney inputProps={inputProps} />
);

export const percentage = ({ inputProps, inputType }) => (
  <div className="form__input-group">
    <input
      {...inputProps}
      value={inputProps.value}
      type="tel"
      className="form__input"
    />
    <span className="form__input-group-addon">
      <i className="fa fa-percent" aria-hidden="true" />
    </span>
  </div>
);

export const date = ({ inputProps, inputType }) => (
  <div className="form__input-group">
    <span className="form__input-group-addon">
      <i className="fa fa-calendar" aria-hidden="true" />
    </span>
    <input
      {...inputProps}
      value={inputProps.value}
      type={inputType}
      className="form__input"
    />
  </div>
);

/**
 * Input container component used to display all the different input types.
 * If adding a new input type you will need to define and return it within this
 * component, and then create a new Input type component extending this container.
 **/
const Input = ({
  values,
  id,
  name,
  label,
  handleInputChange,
  handleInputBlur,
  className,
  required,
  inputType,
  ...props
}) => {
  const inputProps = {
    id: id || name,
    name,
    value: values[name],
    onChange: handleInputChange,
    onBlur: handleInputBlur,
  };

  // Determine the input type set to dynamically change the display of the inputs
  const inputTypes = {
    text,
    select,
    checkbox,
    money,
    percentage,
    date,
  };
  const InputDisplay = inputTypes[inputType];

  return (
    <div {...props} className={classnames('form__field', className)}>
      {label && (
        <label className="form__label" htmlFor={inputProps.id}>
          {label}
          {required === true ? <span className="required"> *</span> : ''}
        </label>
      )}
      <InputDisplay {...props} inputProps={inputProps} inputType={inputType} />
    </div>
  );
};

export default Input;
